import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@ml/shared/shared.module';

import * as fromComponents from './components';
import * as fromContainers from './containers';
import { NotificationsService } from './services';

@NgModule({
  declarations: [...fromContainers.containers, ...fromComponents.components],
  imports: [CommonModule, SharedModule],
  providers: [NotificationsService],
  entryComponents: [...fromContainers.entryContainers]
})
export class NotificationsModule {}
